import request from './request'

/**
 * B端分页查询订单
 * @param {Object} [params] 查询参数
 * @param {number|string} [params.current] 当前页码
 * @param {number|string} [params.size] 每页数量
 * @param {string} [params.endTime] 结束时间
 * @param {string} [params.startTime] 开始时间
 * @param {string} [params.userId] 用户ID（精确查询）
 * @param {string} [params.orderId] 订单ID（精确查询）
 * @param {string} [params.orderStatus] 订单状态：WAIT_PAY-待支付, PAID_FOR-已支付, COMPLETED-已完成, CANCELED-已取消, REFUNDED-已退款, CLOSED-已关闭
 * @param {string} [params.productTitle] 商品标题（模糊查询）
 * @returns {Promise} 返回分页订单列表
 */
export function getOrderPageQuery(params = {}) {
  return request.get('/api/order/page-query', {
    params
  })
}

/**
 * 获取订单统计数据
 * @returns {Promise} 返回订单统计数据
 * @returns {Object} data.totalOrderCount 订单总数
 * @returns {Object}data.todayNewOrderCount 今日新增订单数量
 */
export function getOrderStatistics() {
  return request.get('/api/order/statistics')
}

